import { Alert } from "@/deps/ui-library";
import { usePartyDetails, usePartyStanding } from "@/api/queries";
import type { Party } from "@/api/types";
import { useCan } from "@/app/session";
import { today } from "@/lib/dates";
import { formatAmount } from "@/lib/money";
import { passesLimit } from "./standing";

/** Says when an invoice takes a customer past their limit. It warns: selling over one is your call. */
export function CreditLimitWarning({
  customer,
  invoiceTotal,
}: {
  customer: Party;
  invoiceTotal: string;
}) {
  const can = useCan();
  const seesFigures = can("reports.view");
  const { data: details } = usePartyDetails(customer.id);
  const { data: standing } = usePartyStanding(customer.id, "customer", today(), seesFigures);

  if (!details || !standing) return null;
  if (!passesLimit(standing.outstanding, invoiceTotal, details.creditLimit)) return null;

  return (
    <Alert
      config={{ variant: "subtle", colorScheme: "warning" }}
      description={`This invoice takes ${customer.name} past their credit limit of ${formatAmount(details.creditLimit)}. They already owe ${formatAmount(standing.outstanding)}. You can still save it.`}
    />
  );
}
